module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jzF06"))).then(() => parcelRequire('dJXJK'));